import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import React from 'react';
import { withDimensions } from '../../../../components/withDimensions';
import { sizeClassName, alignmentClassName } from '../../classNameStrategies';
export default function imageComponentWrapper(ExternalComponent) {
    var _React_Component, _ImageComponentWrapper;
    return withDimensions((_ImageComponentWrapper = class ImageComponentWrapper extends (_React_Component = React.Component) {
        render() {
            const { componentData: { config , data  } , width , settings  } = this.props;
            return /*#__PURE__*/ React.createElement(ExternalComponent, {
                config: config,
                data: data,
                width: width,
                settings: settings
            });
        }
        constructor(props){
            super(props);
            this.handleFilesAdded = ({ data , error  })=>{
                const { componentData  } = this.props;
                if (error) {
                    return;
                }
                const deviationData = data.length ? data[0] : data;
                this.props.store.set('componentData', _object_spread_props(_object_spread({}, componentData), {
                    data: deviationData
                }), this.props.block.getKey());
            };
            this.handleFilesSelected = (data)=>{
                const { componentData  } = this.props;
                this.props.store.set('componentData', _object_spread_props(_object_spread({}, componentData), {
                    data
                }), this.props.block.getKey());
            };
            this.handleMetadataChange = (newMetadata)=>{
                const { componentData  } = this.props;
                const metadata = _object_spread({}, componentData.metadata, newMetadata);
                this.props.store.set('componentData', _object_spread_props(_object_spread({}, componentData), {
                    metadata
                }), this.props.block.getKey());
            };
            const { block , store  } = this.props;
            if (store) {
                const blockKey = block.getKey();
                store.setBlockHandler('handleFilesSelected', blockKey, this.handleFilesSelected.bind(this));
                store.setBlockHandler('handleFilesAdded', blockKey, this.handleFilesAdded.bind(this));
                store.setBlockHandler('handleMetadataChange', blockKey, this.handleMetadataChange.bind(this));
            }
        }
    }, _ImageComponentWrapper.sizeClassName = (componentData, theme, styles, isMobile)=>sizeClassName(componentData, theme, styles, isMobile), _ImageComponentWrapper.alignmentClassName = (componentData, theme, styles, isMobile)=>alignmentClassName(componentData, theme, styles, isMobile), _ImageComponentWrapper));
}
